import { useMemo } from "react";
import { useIntl } from "react-intl";

import { TableFilterDropdownProps } from "@nens/ranalib";

import { useProcessListQuery } from "@/queries/query-process";

type UseProcessDropdownProps = {
  selectedProcessId: string | null;
  setSelectedProcessId: (value: string | null) => void;
  setPage: (page: number) => void;
};

export const useProcessDropdown = ({
  selectedProcessId,
  setPage,
  setSelectedProcessId,
}: UseProcessDropdownProps): TableFilterDropdownProps<string | null> => {
  const intl = useIntl();
  const processListQuery = useProcessListQuery();
  const { data } = processListQuery;

  const processes = useMemo(() => data?.items ?? [], [data?.items]);

  const processDropdown: TableFilterDropdownProps<string | null> = useMemo(
    () => ({
      selected: selectedProcessId,
      setSelected: (id: string | null) => {
        setPage(1);
        setSelectedProcessId(id);
      },
      label: intl.formatMessage({
        id: "processes.filter_by_process",
        defaultMessage: "Filter by process",
      }),
      options: [
        {
          value: null,
          label: intl.formatMessage({
            id: "processes.filter_by_process.all",
            defaultMessage: "All processes",
          }),
        },
        ...processes.map((process) => {
          return {
            value: process.id,
            searchBy: process.name,
            label: process.name,
          };
        }),
      ],
    }),
    [intl, processes, selectedProcessId, setPage, setSelectedProcessId]
  );

  return processDropdown;
};
